import { Button, Popover, Row, Space, TableColumnType, Tooltip } from 'antd'
import moment from 'moment'
import React, { ReactElement, useContext } from 'react'
import { useSelector } from 'react-redux'
import {
  AppointmentIcon,
  DeleteOutlined,
  OweMoneyIcon,
  TreatmentFilled,
} from '../../compnents/icons/Icons'
import { DateTimeFormat, DateTimeFormatSimple } from '../../models/datetime'
import { Dimen } from '../../models/dimen'
import {
  getRegistrationStateName,
  getRegistrationStatusColor,
  Registration,
  RegistrationState,
} from '../../models/registration'
import { getGenderName } from '../../models/user'
import { ThemeContext } from '../../theme/ThemeContext'
import { getAge } from '../../utils/StringUtils'
import { selectSettings, selectTenant } from '../user/setting/settingSlice'
import styles from './PatientList.module.css'
import { selectApiUserType, selectInsuranceArray } from '../../app/applicationSlice'
import { WarningOutlined } from '@ant-design/icons'
import { decrypt } from '../../models/m'
import { getOrderSource } from '../../models/payment'
import { selectMenus } from '../../layouts/layoutSlice'
import { getMedicalStateColumnType, getMedicalStateColumnTypeColor } from '../../models/recipe'
import { getMaskPhone } from '../../models/phone'
import { ColDef } from 'ag-grid-community'
import { Checks } from '../../models/setting'

export const RegistrationColumns = (
  onAction: (
    action:
      | 'treatment'
      | 'cancel'
      | 'print'
      | 'register'
      | 'detail'
      | 'convertInsurance'
      | 'registerNoAppoint'
      | 'editPatientInfo',
    reg: Registration
  ) => void,
  startIndex: number,
  patientsMode = false,
  today = false,
  editPatientInfo?: (text?: any, v?: any) => void,
  GHCKHZSJHData?: any
): TableColumnType<Registration>[] => {
  const oweMoneyShow: any = useSelector(selectTenant)
  const theme = useContext(ThemeContext)
  const apiUserType = useSelector(selectApiUserType)

  const allMenus = useSelector(selectMenus)

  const settings = useSelector(selectSettings)

  const yjfzFlg = allMenus?.find((v: any) => v?.name == '综合服务')?.subMenus?.filter((n) => n?.name == '预检分诊')
  const insuranceArray = useSelector(selectInsuranceArray)
  const columns: TableColumnType<any>[] = [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, i) => `${1 + i + startIndex}`,
    },
    {
      title: '门诊号',
      dataIndex: 'outpatientNo',
      width: Dimen.OutpatientNo,
      align: 'center',
      render: (_, t) => {
        return Number(t.outpatientNo) > 0 ? t.outpatientNo : '-'
      },
    },
    {
      title: '患者姓名',
      dataIndex: 'patientName',
      width: '10em',
      align: 'center',
      ellipsis: true,
      render: function action(_, t) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {location.pathname == '/registration' ? (
              <span
                style={{
                  color: '#027AFF',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  onAction('editPatientInfo', t)
                }}
              >
                {_}
              </span>
            ) : (
              <span>{_}</span>
            )}
            {t.appointmentId != -1 && (
              <AppointmentIcon
                style={{ marginLeft: '5px', width: '18px', height: '18px' }}
              />
            )}
            {t.arrearageAmountSum &&
              t.arrearageAmountSum > 0 &&
              oweMoneyShow?.openOwe == 1 ? (
              <Tooltip title={`欠费金额 ${t.arrearageAmountSum} 元`}>
                <div style={{ marginTop: '8px' }}>
                  <OweMoneyIcon
                    style={{ marginLeft: '5px', width: '18px', height: '18px' }}
                  />
                </div>
              </Tooltip>
            ) : (
              ''
            )}
            {!!t.labels.length &&
              t.labels.map((v: any) => (
                <Tooltip key={v.id} title={v.name}>
                  <span
                    className={styles.label}
                    style={{
                      backgroundColor: v.backgroundColor,
                      color: v.fontColor,
                      borderRadius: '50%',
                    }}
                  >
                    {v.headName}
                  </span>
                </Tooltip>
              ))}
          </div>
        )
      },
    },
    {
      title: '病历号',
      key: 'patientId',
      width: '6.5rem',
      ellipsis: true,
      align: 'center',
      dataIndex: 'patientId',
    },
    {
      title: '结算险种',
      dataIndex: 'insuranceCode',
      width: '9em',
      align: 'center',
      ellipsis: true,
      render: (_, t) => {
        return !t || !t.insuranceCode || t.insuranceCode === 'ZIFEI'
          ? '自费'
          : '智慧医保'
      },
    },
    {
      title: '性别',
      key: 'gender',
      width: '5rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => getGenderName(r.patientSex),
    },
    {
      title: '年龄',
      dataIndex: 'patientAge',
      width: '5rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => getAge(r.patientAge, r.patientMonth),
    },
    {
      title: '手机号',
      dataIndex: 'patientPhone',
      key: 'patientPhone',
      width: '7rem',
      ellipsis: true,
      align: 'center',
      render: (_, r) => {
        if (location.pathname == '/registration') {
          return r?.patientPhone ? !GHCKHZSJHData ? getMaskPhone(decrypt(r?.patientPhone)) : decrypt(r?.patientPhone) : '-'
        } else if (location.pathname == '/patients') {
          return r?.patientPhone ? !GHCKHZSJHData ? getMaskPhone(decrypt(r?.patientPhone)) : decrypt(r?.patientPhone) : '-'
        } else {
          return r?.patientPhone ? r?.patientPhone : '-'
        }
      },
    },
    {
      title: patientsMode ? '就诊科室' : '挂号科室',
      dataIndex: patientsMode
        ? 'treatmentDepartmentName'
        : 'registrationDepartmentName',
      width: '6.5rem',
      ellipsis: true,
      align: 'center',
      render: function Actions(_, r): ReactElement | undefined {
        return patientsMode ? (
          <div
            style={{
              color:
                r?.treatmentDepartmentName == '未指定科室' ? '#2D7BFF' : '#333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (r?.treatmentDepartmentName == '未指定科室') {
                onAction('registerNoAppoint', r)
              }
            }}
          >
            {r?.treatmentDepartmentName}
          </div>
        ) : (
          <div
            style={{
              color:
                r?.registrationDepartmentName == '未指定科室'
                  ? '#2D7BFF'
                  : '#333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (r?.registrationDepartmentName == '未指定科室') {
                onAction('registerNoAppoint', r)
              }
            }}
          >
            {r?.registrationDepartmentName}
          </div>
        )
      },
    },
    {
      title: patientsMode ? '就诊医生' : '挂号医生',
      dataIndex: patientsMode
        ? 'treatmentDoctorName'
        : 'registrationDoctorName',
      ellipsis: true,
      width: '6.5rem',
      align: 'center',
      render: function Actions(_, r): ReactElement | undefined {
        return patientsMode ? (
          <div
            style={{
              color:
                r?.treatmentDoctorName == '未指定医生' ? '#2D7BFF' : '#333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (r?.treatmentDoctorName == '未指定医生') {
                onAction('registerNoAppoint', r)
              }
            }}
          >
            {r?.treatmentDoctorName}
          </div>
        ) : (
          <div
            style={{
              color:
                r?.registrationDoctorName == '未指定医生' ? '#2D7BFF' : '#333',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
            onClick={() => {
              if (r?.registrationDoctorName == '未指定医生') {
                onAction('registerNoAppoint', r)
              }
            }}
          >
            {r?.registrationDoctorName}
          </div>
        )
      },
    },
    {
      title: '就诊状态',
      key: 'state',
      ellipsis: true,
      width: '6.5rem',
      align: 'center',
      render: function Element(_, r: any) {
        return (
          <>
            {/* r?.orderSource == 1 */}
            {r?.statusFlag == 1 &&
              location.pathname == '/patients' ? (
              <Popover placement='top' content={<span>主诉尚未填写完整</span>}>
                <div
                  style={{
                    padding: '0 8px',
                    background: 'rgb(204, 204, 204,.3)',
                  }}
                >
                  <span
                    style={{
                      marginTop: '10px',
                      cursor: 'pointer',
                      color: '#e47a1f',
                    }}
                  >
                    {getRegistrationStateName(r.registrationState)}
                    {settings?.[Checks.Blwzxjy] ? (
                      <WarningOutlined
                        style={{
                          color: '#e47a1f',
                          marginLeft: '2px',
                          marginTop: '4px',
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </span>
                </div>
              </Popover>
            ) : (
              <div
                style={{
                  background: getRegistrationStatusColor(
                    Number(r.registrationState)
                  ),
                  padding: '0 8px',
                }}
              >
                <span
                  style={{
                    color: '#333 ',
                  }}
                >
                  {getRegistrationStateName(Number(r.registrationState))}
                </span>
              </div>
            )}
          </>
        )
      },
    },
    {
      title: '病历状态',
      key: 'medicalStatus',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: function Status(_: any, t: any) {
        return <span style={{
          color: getMedicalStateColumnTypeColor(t.medicalState),
        }}>{getMedicalStateColumnType(t.medicalState)}</span>
      },
    },
    {
      title: '来源',
      key: 'orderSource',
      align: 'center',
      width: '8em',
      ellipsis: true,
      render: (_, v: any) => getOrderSource(v?.orderSource),
    },
    {
      title: '挂号时间',
      dataIndex: 'registrationTime',
      width: '9.5rem',
      align: 'center',
      ellipsis: true,
      render: (_, r) => {
        return moment(r.registrationTime).format(DateTimeFormat)
      },
    },
    {
      title: '预检分诊',
      key: 'yjfz',
      dataIndex: 'precheckState',
      width: '7rem',
      ellipsis: true,
      align: 'center',
      render: function Actions(_, r): ReactElement | undefined {
        return (
          <Space>
            {r.precheckState == 0 ? (
              <Row>
                <Button
                  type='text'
                  style={{
                    color: '#333',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => onAction('register', r)}
                >
                  登记
                </Button>
              </Row>
            ) : r.precheckState == 1 ? (
              <Row>
                <Button
                  size='small'
                  type='text'
                  style={{
                    color: '#027aff',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => onAction('detail', r)}
                >
                  详情
                </Button>
              </Row>
            ) : (
              <></>
            )}
          </Space>
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: patientsMode ? '12rem' : '18rem',
      render: function Actions(_, r): ReactElement | undefined {
        if (patientsMode) {
          return r.registrationState === RegistrationState.NotTreated ||
            r.registrationState === RegistrationState.Treating ||
            today ? (
            <div>
              <Button
                size='small'
                type='primary'
                style={{ marginRight: '10px' }}
                onClick={() => {
                  if (patientsMode) {
                    if (
                      r?.treatmentDepartmentName == '未指定科室' &&
                      r?.treatmentDoctorName == '未指定医生'
                    ) {
                      onAction('registerNoAppoint', r)
                    } else {
                      onAction('treatment', r)
                    }
                  } else {
                    if (
                      r?.registrationDepartmentName == '未指定科室' &&
                      r?.registrationDoctorName == '未指定医生'
                    ) {
                      onAction('registerNoAppoint', r)
                    } else {
                      onAction('treatment', r)
                    }
                  }
                }}
              >
                就诊
              </Button>
              {insuranceArray.length !== 0 && r.insuranceCode === 'ZIFEI' && apiUserType !== 'SYLD' && (
                <Button
                  style={{ backgroundColor: '#4dbd17', borderColor: '#4dbd17' }}
                  size='small'
                  type='primary'
                  onClick={() => {
                    onAction('convertInsurance', r)
                  }}
                >
                  自费转医保
                </Button>
              )}
              {insuranceArray.length !== 0 && r.insuranceCode != 'ZIFEI' && apiUserType !== 'SYLD' && (
                <Button
                  style={{ backgroundColor: '#fa8714', borderColor: '#fa8714' }}
                  size='small'
                  type='primary'
                  onClick={() => {
                    onAction('convertInsurance', r)
                  }}
                >
                  医保转自费
                </Button>
              )}
            </div>
          ) : (
            <div>
              <Button
                size='small'
                type='primary'
                style={{ marginRight: '10px' }}
                onClick={() => {
                  onAction('treatment', r)
                }}
              >
                查看详情
              </Button>
              {insuranceArray.length !== 0 && r.insuranceCode === 'ZIFEI' && apiUserType !== 'SYLD' && (
                <Button
                  style={{ backgroundColor: '#4dbd17', borderColor: '#4dbd17' }}
                  size='small'
                  type='primary'
                  onClick={() => {
                    onAction('convertInsurance', r)
                  }}
                >
                  自费转医保
                </Button>
              )}
              {insuranceArray.length !== 0 && r.insuranceCode != 'ZIFEI' && apiUserType !== 'SYLD' && (
                <Button
                  style={{ backgroundColor: '#fa8714', borderColor: '#fa8714' }}
                  size='small'
                  type='primary'
                  onClick={() => {
                    onAction('convertInsurance', r)
                  }}
                >
                  医保转自费
                </Button>
              )}
            </div>
          )
        } else {
          const isNotTreated =
            r.registrationState === RegistrationState.NotTreated
          const isTreated = r.registrationState === RegistrationState.Treated
          const isCanceled = r.registrationState === RegistrationState.Canceled
          return (
            <Space style={{ whiteSpace: 'nowrap' }}>
              {!(isTreated || isCanceled) && (
                <a
                  onClick={() => {
                    if (!isCanceled) {
                      if (patientsMode) {
                        if (
                          r?.treatmentDepartmentName == '未指定科室' &&
                          r?.treatmentDoctorName == '未指定医生'
                        ) {
                          onAction('registerNoAppoint', r)
                        } else {
                          onAction('treatment', r)
                        }
                      } else {
                        if (
                          r?.registrationDepartmentName == '未指定科室' &&
                          r?.registrationDoctorName == '未指定医生'
                        ) {
                          onAction('registerNoAppoint', r)
                        } else {
                          onAction('treatment', r)
                        }
                      }
                      // onAction('treatment', r)
                    }
                  }}
                  style={{
                    color: isCanceled ? theme.tc3 : theme.tc2,
                    width: '14px',
                    height: '14px',
                  }}
                >
                  <Row align='middle' wrap={false}>
                    <TreatmentFilled
                      mode='small'
                      style={{
                        fill: isCanceled ? theme.tc3 : theme.s,
                        marginRight: 4,
                      }}
                    />
                    就诊
                  </Row>
                </a>
              )}
              {/* {isNotTreated && ( */}
              <a
                onClick={() => {
                  if (!isCanceled) {
                    onAction('cancel', r)
                  }
                }}
                style={{ color: isCanceled ? theme.tc3 : theme.tc2 }}
              >
                <Row align='middle' wrap={false}>
                  <DeleteOutlined
                    mode='small'
                    style={{
                      fill: isCanceled ? theme.tc3 : theme.e,
                      marginRight: 4,
                      width: '14px',
                      height: '14px',
                    }}
                  />
                  删除
                </Row>
              </a>
              {/* )} */}
              {isTreated && (
                <a onClick={() => onAction('treatment', r)}>继续就诊</a>
              )}
              {/* {!isNotTreated && ( */}
              <a
                style={isCanceled ? { color: theme.tc3 } : undefined}
                onClick={() => {
                  onAction('print', r)
                }}
              >
                打印
              </a>
              {/* )} */}
            </Space>
          )
        }
      },
    },
  ]
  return yjfzFlg?.length ? columns : columns?.filter((v) => v?.key != 'yjfz')
}


export const AGColumns = (
  onAction: (
    action:
      | 'treatment'
      | 'cancel'
      | 'print'
      | 'register'
      | 'detail'
      | 'convertInsurance'
      | 'registerNoAppoint'
      | 'editPatientInfo',
    reg: Registration
  ) => void,
  startIndex: number,
  patientsMode = false,
  today = false,
  editPatientInfo?: (text?: any, v?: any) => void,
  GHCKHZSJHData?: any,
  columnList?: any,
): ColDef[] => {
  const oweMoneyShow: any = useSelector(selectTenant)

  const theme = useContext(ThemeContext)

  const settings = useSelector(selectSettings)

  console.log(settings, "settings")

  const apiUserType = useSelector(selectApiUserType)

  const insuranceArray = useSelector(selectInsuranceArray)

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'outpatientNo': //门诊号
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = Number(t?.[field])
              return Number(val) > 0 ? val : '-'
            },
          };
        case 'patientName'://患者姓名
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: function patientName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              // 确保只在合适的状态下显示退费按钮，避免重复显示
              return (
                <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',height:'41px' }}>
                  {location.pathname == '/registration' ? (
                    <span
                      style={{
                        color: '#027AFF',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        onAction('editPatientInfo', t)
                      }}
                    >
                      {t.patientName}
                    </span>
                  ) : (
                    <span>{t.patientName}</span>
                  )}
                  {t.appointmentId != -1 && (
                    <AppointmentIcon
                      style={{ marginLeft: '5px', width: '18px', height: '18px' }}
                    />
                  )}
                  {t.arrearageAmountSum &&
                    t.arrearageAmountSum > 0 &&
                    oweMoneyShow?.openOwe == 1 ? (
                    <Tooltip title={`欠费金额 ${t.arrearageAmountSum} 元`}>
                      <div style={{ marginTop: '8px' }}>
                        <OweMoneyIcon
                          style={{ marginLeft: '5px', width: '18px', height: '18px' }}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    ''
                  )}
                  {!!t.labels.length &&
                    t.labels.map((v: any) => (
                      <Tooltip key={v.id} title={v.name}>
                        <span
                          className={styles.label}
                          style={{
                            backgroundColor: v.backgroundColor,
                            color: v.fontColor,
                            borderRadius: '50%',
                          }}
                        >
                          {v.headName}
                        </span>
                      </Tooltip>
                    ))}
                </div>
              )
            }
          };
        case 'patientId': //病历号
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const field = item.field;
              const val = t?.[field]
              return val;
            },
          };
        case 'insuranceCode': //结算险种
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return !t || !t.insuranceCode || t.insuranceCode === 'ZIFEI' ? '自费' : '智慧医保'
            },
          };
        case 'patientSex': //性别
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return getGenderName(Number(t?.patientSex))
            },
          };
        case 'patientAge': //年龄
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              return getAge(t?.patientAge, t?.patientMonth)
            },
          };
        case 'patientPhone': //手机号
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              if (params.node.rowPinned) return '';
              if (location.pathname == '/registration') {
                return t?.patientPhone ? !GHCKHZSJHData ? getMaskPhone(decrypt(t?.patientPhone)) : decrypt(t?.patientPhone) : '-'
              } else if (location.pathname == '/patients') {
                return t?.patientPhone ? !GHCKHZSJHData ? getMaskPhone(decrypt(t?.patientPhone)) : decrypt(t?.patientPhone) : '-'
              } else {
                return t?.patientPhone ? t?.patientPhone : '-'
              }
            },
          };
        case 'treatmentDepartmentName': //就诊科室
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const r = params.data;
              return patientsMode ? (
                <div
                  style={{
                    color:
                      r?.treatmentDepartmentName == '未指定科室'
                        ? '#2D7BFF'
                        : r?.settlementStatus == '5' ?
                          '#999' : '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (r?.treatmentDepartmentName == '未指定科室') {
                      onAction('registerNoAppoint', r)
                    }
                  }}
                >
                  {r?.treatmentDepartmentName}
                </div>
              ) : (
                <div
                  style={{
                    color:
                      r?.registrationDepartmentName == '未指定科室'
                        ? '#2D7BFF'
                        : r?.settlementStatus == '5' ? '#999' : '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (r?.registrationDepartmentName == '未指定科室') {
                      onAction('registerNoAppoint', r)
                    }
                  }}
                >
                  {r?.registrationDepartmentName}
                </div>
              )
            }
          };
        case 'treatmentDoctorName': //就诊医生
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
              };
            },
            cellRendererFramework: function treatmentDoctorName(params: any) {
              if (params.node.rowPinned) return '';
              const r = params.data;
              return patientsMode ? (
                <div
                  style={{
                    color:
                      r?.treatmentDoctorName == '未指定医生'
                        ? '#2D7BFF'
                        : r?.settlementStatus == '5' ?
                          '#999' :
                          '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (r?.treatmentDoctorName == '未指定医生') {
                      onAction('registerNoAppoint', r)
                    }
                  }}
                >
                  {r?.treatmentDoctorName}
                </div>
              ) : (
                <div
                  style={{
                    color:
                      r?.registrationDoctorName == '未指定医生'
                        ? '#2D7BFF'
                        : r?.settlementStatus == '5' ?
                          '#999' :
                          '#333',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (r?.registrationDoctorName == '未指定医生') {
                      onAction('registerNoAppoint', r)
                    }
                  }}
                >
                  {r?.registrationDoctorName}
                </div>
              )
            }
          };
        case 'state':// 就诊状态
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const r = params.data;
              return (
                <>
                  {/* r?.orderSource == 1 */}
                  {r?.statusFlag == 1 &&
                    location.pathname == '/patients' ? (
                    settings?.[Checks.Blwzxjy] != false ?
                      <Popover placement='top' content={<span>主诉尚未填写完整</span>}>
                        <div
                          style={{
                            padding: '0 8px',
                            background: 'rgb(204, 204, 204,.3)',
                          }}
                        >
                          <span
                            style={{
                              marginTop: '10px',
                              cursor: 'pointer',
                              color: '#e47a1f',
                            }}
                          >
                            {getRegistrationStateName(r.registrationState)}
                            <WarningOutlined
                              style={{
                                color: '#e47a1f',
                                marginLeft: '2px',
                                marginTop: '4px',
                              }}
                            />
                          </span>
                        </div>
                      </Popover> :
                      <div
                        style={{
                          padding: '0 8px',
                          background: 'rgb(204, 204, 204,.3)',
                        }}
                      >
                        <span
                          style={{
                            marginTop: '10px',
                          }}
                        >
                          {getRegistrationStateName(r.registrationState)}
                        </span>
                      </div>
                  ) : (
                    <div
                      style={{
                        background: getRegistrationStatusColor(
                          Number(r.registrationState)
                        ),
                        padding: '0 8px',
                      }}
                    >
                      <span
                        style={{
                          color: '#333 ',
                        }}
                      >
                        {getRegistrationStateName(Number(r.registrationState))}
                      </span>
                    </div>
                  )}
                </>
              )
            }
          };
        case 'settlementStatus':// 结算状态
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (<span>{t?.settlementStatus == '0' ? '待收费' : t?.settlementStatus == '3' ? '已收费' : t?.settlementStatus == '5' ? '已退费' : ''}</span>)
            }
          };
        case 'medicalStatus':// 病历状态
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return (<span style={{
                color: getMedicalStateColumnTypeColor(t.medicalState),
              }}>{getMedicalStateColumnType(t.medicalState)}</span>)
            }
          };
        case 'orderSource':// 来源
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return getOrderSource(t?.orderSource)
            }
          };
        case 'registrationTime':// 挂号时间
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#333'
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              return moment(t.registrationTime).format(DateTimeFormat)
            }
          };
        case 'yjfz':// 预检分诊
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                color: t?.settlementStatus == '5' ? '#999' : '#3333'
              };
            },
            cellRendererFramework: function treatmentDepartmentName(params: any) {
              if (params.node.rowPinned) return '';
              const r = params.data;
              return (
                <Space>
                  {r.precheckState == 0 ? (
                    <Row>
                      <Button
                        type='text'
                        style={{
                          color: '#333',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={() => onAction('register', r)}
                      >
                        登记
                      </Button>
                    </Row>
                  ) : r.precheckState == 1 ? (
                    <Row>
                      <Button
                        size='small'
                        type='text'
                        style={{
                          color: '#027aff',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                        onClick={() => onAction('detail', r)}
                      >
                        详情
                      </Button>
                    </Row>
                  ) : (
                    <></>
                  )}
                </Space>
              )
            }
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: function columnAction(params: any) {
              if (params.node.rowPinned) return '';
              const r = params.data;
              if (patientsMode) {
                return r.registrationState === RegistrationState.NotTreated ||
                  r.registrationState === RegistrationState.Treating ||
                  today ? (
                  <div>
                    <Button
                      size='small'
                      type='primary'
                      style={{ marginRight: '10px' }}
                      onClick={() => {
                        if (patientsMode) {
                          if (
                            r?.treatmentDepartmentName == '未指定科室' &&
                            r?.treatmentDoctorName == '未指定医生'
                          ) {
                            onAction('registerNoAppoint', r)
                          } else {
                            onAction('treatment', r)
                          }
                        } else {
                          if (
                            r?.registrationDepartmentName == '未指定科室' &&
                            r?.registrationDoctorName == '未指定医生'
                          ) {
                            onAction('registerNoAppoint', r)
                          } else {
                            onAction('treatment', r)
                          }
                        }
                      }}
                    >
                      就诊
                    </Button>
                    {insuranceArray.length !== 0 && r.insuranceCode === 'ZIFEI' && apiUserType !== 'SYLD' && (
                      <Button
                        style={{ backgroundColor: '#4dbd17', borderColor: '#4dbd17' }}
                        size='small'
                        type='primary'
                        onClick={() => {
                          onAction('convertInsurance', r)
                        }}
                      >
                        自费转医保
                      </Button>
                    )}
                    {insuranceArray.length !== 0 && r.insuranceCode != 'ZIFEI' && apiUserType !== 'SYLD' && (
                      <Button
                        style={{ backgroundColor: '#fa8714', borderColor: '#fa8714' }}
                        size='small'
                        type='primary'
                        onClick={() => {
                          onAction('convertInsurance', r)
                        }}
                      >
                        医保转自费
                      </Button>
                    )}
                  </div>
                ) : (
                  <div>
                    <Button
                      size='small'
                      type='primary'
                      style={{ marginRight: '10px' }}
                      onClick={() => {
                        onAction('treatment', r)
                      }}
                    >
                      查看详情
                    </Button>
                    {insuranceArray.length !== 0 && r.insuranceCode === 'ZIFEI' && apiUserType !== 'SYLD' && (
                      <Button
                        style={{ backgroundColor: '#4dbd17', borderColor: '#4dbd17' }}
                        size='small'
                        type='primary'
                        onClick={() => {
                          onAction('convertInsurance', r)
                        }}
                      >
                        自费转医保
                      </Button>
                    )}
                    {insuranceArray.length !== 0 && r.insuranceCode != 'ZIFEI' && apiUserType !== 'SYLD' && (
                      <Button
                        style={{ backgroundColor: '#fa8714', borderColor: '#fa8714' }}
                        size='small'
                        type='primary'
                        onClick={() => {
                          onAction('convertInsurance', r)
                        }}
                      >
                        医保转自费
                      </Button>
                    )}
                  </div>
                )
              } else {
                const isNotTreated =
                  r.registrationState === RegistrationState.NotTreated
                const isTreated = r.registrationState === RegistrationState.Treated
                const isCanceled = r.registrationState === RegistrationState.Canceled
                return (
                  <Space style={{ whiteSpace: 'nowrap' }}>
                    {!(isTreated || isCanceled) && (
                      <a
                        onClick={() => {
                          if (!isCanceled) {
                            if (patientsMode) {
                              if (
                                r?.treatmentDepartmentName == '未指定科室' &&
                                r?.treatmentDoctorName == '未指定医生'
                              ) {
                                onAction('registerNoAppoint', r)
                              } else {
                                onAction('treatment', r)
                              }
                            } else {
                              if (
                                r?.registrationDepartmentName == '未指定科室' &&
                                r?.registrationDoctorName == '未指定医生'
                              ) {
                                onAction('registerNoAppoint', r)
                              } else {
                                onAction('treatment', r)
                              }
                            }
                            // onAction('treatment', r)
                          }
                        }}
                        style={{
                          color: isCanceled ? theme.tc3 : theme.tc2,
                          width: '14px',
                          height: '14px',
                        }}
                      >
                        <Row align='middle' wrap={false}>
                          <TreatmentFilled
                            mode='small'
                            style={{
                              fill: isCanceled ? theme.tc3 : theme.s,
                              marginRight: 4,
                            }}
                          />
                          就诊
                        </Row>
                      </a>
                    )}
                    {/* {isNotTreated && ( */}
                    <a
                      onClick={() => {
                        if (!isCanceled) {
                          onAction('cancel', r)
                        }
                      }}
                      style={{ color: isCanceled ? theme.tc3 : theme.tc2 }}
                    >
                      <Row align='middle' wrap={false}>
                        <DeleteOutlined
                          mode='small'
                          style={{
                            fill: isCanceled ? theme.tc3 : theme.e,
                            marginRight: 4,
                            width: '14px',
                            height: '14px',
                          }}
                        />
                        删除
                      </Row>
                    </a>
                    {/* )} */}
                    {isTreated && (
                      <a onClick={() => onAction('treatment', r)}>继续就诊</a>
                    )}
                    {/* {!isNotTreated && ( */}
                    <a
                      style={isCanceled ? { color: theme.tc3 } : undefined}
                      onClick={() => {
                        onAction('print', r)
                      }}
                    >
                      打印
                    </a>
                    {/* )} */}
                  </Space>
                )
              }

            }
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
          };
      }
    })
  )
}